import { cn } from "@/utils/utils";

interface Props {
  className?: string;
}

const WidgetSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        "bg-gradient-to-r from-surface-elevation1 to-surface-elevation3 animate-[pulse_2s_cubic-bezier(0.4,0,0.6,1)_infinite]",
        className
      )}
    />
  );
};

export default WidgetSkeleton;
